import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { MenuService } from './../../services/menu.service';

@Component({
  selector: 'app-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrls: ['./breadcrumbs.component.scss']
})
export class BreadcrumbsComponent implements OnInit {
  tempState = [];
  breadcrumbs: Array<Object>;
  constructor(private router: Router, private route: ActivatedRoute, private titleService: Title, private menuItems: MenuService) {
    this.router.events
      .filter(event => event instanceof NavigationEnd)
      .subscribe(event => {  // note, we don't use event
        this.breadcrumbs = [];
        this.tempState = [];
        let currentRoute = this.route.root,
          url = '', nomModulo1 = '', nomModulo2 = '', nomModulo3 = '';
          let modulo = this.router.routerState.snapshot.url.split('/');
          //console.log("modulo ", this.router.routerState.snapshot.url.split('/'));
          if (modulo[1] != '') {
            if (modulo[1] == 'menu') {
              nomModulo1 = 'Home';
            } else {
              nomModulo1 = this.menuItems.getNavMenu(modulo[1])[0].main[0].name;
            }
            //console.log("modulo name 1", nomModulo1);
          }

          if (modulo[2]) {
            let nomOpcionChildren = this.menuItems.getNavMenu(modulo[1])[0].main[0].children;
            //console.log("nomOpcionChildren ", nomOpcionChildren);
            nomOpcionChildren.forEach(childrenRoutes => {
              if (childrenRoutes.state == modulo[2]) {
                nomModulo2 = ' / ' + childrenRoutes.name;
              }
            });
            //console.log("modulo name 2", nomModulo2);
          }

          if (modulo[3]) {
            let nomOpcionChildren = this.menuItems.getNavMenu(modulo[1])[0].main[0].children;
            nomOpcionChildren.forEach(childrenRoutes => {
              if (childrenRoutes.state == modulo[2]) {
                console.log(childrenRoutes)
                if(childrenRoutes.children){
                  childrenRoutes.children.forEach(childrenRoutesChildren => {
                    if (childrenRoutesChildren.state == modulo[3]) {
                      nomModulo3 = ' / ' + childrenRoutesChildren.name;
                    }
                  });
                }
              }
            });
            //console.log("modulo name 3", nomModulo3);
          }

        do {
          const childrenRoutes = currentRoute.children;
          currentRoute = null;
          childrenRoutes.forEach(routes => {
            if (routes.outlet === 'primary') {
              const routeSnapshot = routes.snapshot;
              url += '/' + routeSnapshot.url.map(segment => segment.path).join('/');
              //console.log("url ", url);
              if (routes.snapshot.data.breadcrumb !== undefined) {
                let status = true;
                if (routes.snapshot.data.status !== undefined) {
                  status = routes.snapshot.data.status;
                }
                if (!this.tempState.includes(routes.snapshot.data.breadcrumb)) {
                  this.tempState.push(routes.snapshot.data.breadcrumb);
                  this.breadcrumbs.push({
                    label: routes.snapshot.data.breadcrumb,
                    status: status,
                    url: url,
                    location1: (nomModulo1) ? nomModulo1 : '',
                    location2: (nomModulo2) ? nomModulo2 : '',
                    location3: (nomModulo3) ? nomModulo3 : ''
                  });
                }

              }
              currentRoute = routes;
            }
          });
          //modulo = [];
        } while (currentRoute);
      });
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/breadcrumbs/breadcrumbs.component.ts